<template>
	<div>
		<div class="form-container">
			<form @submit.prevent="onSubmitForm">
				<h2 class="form-title">
					하이모 온라인<br />
					통합 서비스 가입 약관
				</h2>

				<div class="form-group mb-0">
					<label class="form-checkbox">
						<input
							@change="changeAllCheck"
							v-model="checkAll"
							type="checkbox"
						/>
						<i class="form-icon"></i> 전체 동의합니다.
					</label>
					<p class="form-indent form-info">
						<span class="form-info__underline"
							>※ 선택동의 사항이 포함 되어 있습니다.</span
						>
					</p>
				</div>

				<hr class="form-hr" />

				<div class="form-group mb-0">
					<div class="columns flex-centered">
						<div class="column col-auto mb-0">
							<label class="form-checkbox">
								<input
									@change="changeRequired"
									v-model="requiredCheck.checkAgreement"
									type="checkbox"
								/>
								<i class="form-icon"></i> 회원 이용 약관 동의
								<span class="form-help form-help--required">(필수)</span>
							</label>
						</div>
						<div class="column col-auto col-ml-auto mb-0">
							<a
								@click="openModal('ModalAgreement')"
								class="form-info"
								href="javascript:;"
							>
								<span class="form-info__underline">보기</span></a
							>
						</div>
					</div>
				</div>

				<div class="form-group mb-0">
					<div class="columns flex-centered">
						<div class="column col-auto mb-0">
							<label class="form-checkbox">
								<input
									@change="changeRequired"
									v-model="requiredCheck.checkPrivacy"
									type="checkbox"
								/>
								<i class="form-icon"></i> 개인정보 처리 방침 동의
								<span class="form-help form-help--required">(필수)</span>
							</label>
						</div>
						<div class="column col-auto col-ml-auto mb-0">
							<a
								@click="openModal('ModalPrivacy')"
								class="form-info"
								href="javascript:;"
							>
								<span class="form-info__underline">보기</span></a
							>
						</div>
					</div>

					<ul class="agree-require-list">
						<li>
							<h3>목적</h3>
							<div>회원가입/유지/서비스이용 등을 위한 연락처</div>
						</li>
						<li>
							<h3>항목</h3>
							<div>이름, 아이디, 비밀번호, 이메일, 생년월일 등</div>
						</li>
						<li>
							<h3>보유기간</h3>
							<div>회원탈퇴 시 즉시 파기</div>
						</li>
					</ul>
				</div>

				<div class="form-group mb-0">
					<div class="columns flex-centered">
						<div class="column col-auto mb-0">
							<label class="form-checkbox">
								<input
									@change="changeSelectedAllCheck"
									v-model="checkSelectedAll"
									type="checkbox"
								/>
								<i class="form-icon"></i> 이벤트 및 제품 정보 수신 동의
								<span class="form-help">(선택)</span>
							</label>
						</div>
						<div class="column col-auto col-ml-auto mb-0">
							<!--
                            <a class="form-info" href="#"><span class="form-info__underline">보기</span></a>
                            -->
						</div>
					</div>

					<div class="form-indent">
						<div class="columns">
							<div class="column col-4 mb-0">
								<label class="form-checkbox">
									<input v-model="selectedCheck.checkSms" type="checkbox" />
									<i class="form-icon"></i> SMS
								</label>
							</div>
							<div class="column col-4 mb-0">
								<label class="form-checkbox">
									<input v-model="selectedCheck.checkEmail" type="checkbox" />
									<i class="form-icon"></i> 이메일
								</label>
							</div>
						</div>
					</div>

					<p class="form-info form-indent">
						<span class="form-info__underline"
							>※ 선택 사항에 동의하지 않으셔도 서비스 가입 및 이용이
							가능합니다.</span
						>
					</p>
				</div>

				<div class="form-group form-button">
					<Btn type="submit" color="primary" x-large block :disabled="!isSubmit"
						>다음</Btn
					>
				</div>
			</form>
		</div>

		<component v-if="modalComp" :is="modalComp" />
	</div>
</template>

<script>
import Btn from '@/components/common/Btn';

export default {
	components: {
		Btn,
	},
	data() {
		return {
			// 일괄 체크
			checkAll: false,
			// 선택 일괄 체크
			checkSelectedAll: false,
			// 필수 체크
			requiredCheck: {
				checkAgreement: false,
				checkPrivacy: false,
			},
			// 선택 체크
			selectedCheck: {
				checkSms: 0,
				checkEmail: 0,
			},
			// 다음 버튼 활성화 여부
			isSubmit: false,
			modalComp: null,
		};
	},
	methods: {
		openModal(compName) {
			if (!compName) return;

			this.modalComp = async () =>
				(await import(`@/components/${compName}.vue`)).default;
		},
		changeAllCheck() {
			const checked = this.checkAll;

			this.checkSelectedAll = checked;

			for (const key in this.requiredCheck) {
				this.requiredCheck[key] = checked;
			}
			for (const key in this.selectedCheck) {
				this.selectedCheck[key] = checked;
			}

			this.changeSubmitState();
		},
		changeRequired() {
			this.changeSubmitState();
		},
		changeSelectedAllCheck() {
			const checked = this.checkSelectedAll;

			for (const key in this.selectedCheck) {
				this.selectedCheck[key] = checked;
			}
		},
		changeSubmitState() {
			for (const checked of Object.values(this.requiredCheck)) {
				if (!checked) {
					this.isSubmit = false;
					return;
				}
			}

			this.isSubmit = true;
		},
		onSubmitForm() {
			// 수신 동의 스토어에 저장
			const userSms = this.selectedCheck.checkSms ? 1 : 0;
			const userMailing = this.selectedCheck.checkEmail ? 1 : 0;
			this.$store.commit('signupStore/setUserSms', userSms);
			this.$store.commit('signupStore/setUserMailing', userMailing);

			// 다음 단계
			const nextStep = this.$parent.step + 1;
			this.$emit('changeStep', nextStep);
		},
	},
};
</script>

<style scoped>
.agree-require-list {
	border: 1px solid #ddd;
	padding: 0.5em 1em;
}

.agree-require-list li {
	display: flex;
	font-size: 0.8125rem;
	margin: 0.5em 0;
}

.agree-require-list li h3 {
	color: #888;
	font-weight: 500;
	flex: 0 0 60px;
}
</style>
